import { useEffect, useState } from "react"
import { REQUEST_METHOD } from '@laramie/ui';
import { ServerRequest } from "../../../utils/apiweb"
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import {TIPS} from "../../../consts/tips";

import { FormError, Modal, FormLabel } from "../../common"
import { useForm, useFormErrors, useManagedContext } from "../../hooks"
import { isNull, isValidNumber } from "../../../utils/validator"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const entityInit = {
    id: -1,
    codigo: '',
    orden: '',
    nombre: '',
    matricula: '',
}

const EscribanoModal = (props) => {
    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _, formSet] = useForm({
        codigo: '',
        orden: '',
        nombre: '',
        matricula: '',
    })

    useEffect(() => {
        const { codigo, orden, nombre, matricula } = props.escribano

        setEntity(props.escribano)
        formSet({ codigo, orden, nombre, matricula })
    }, [props.escribano])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.matricula.length < 1) errors.matricula = VALIDATION_MESSAGE.REQUIRED_SHORT

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (props.editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const onConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            props.editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.ESCRIBANO,
            props.editMode === 'modify' ? `/${entity.id}` : '',
            {...entity, ...formValues, orden: parseInt(formValues.orden) ?? 0},
            res => res.json().then(() => {
                setIsLoading(false)
                props.onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    const disabled = props.editMode === 'view'

    return <>
        <Modal
            onEscape={props.onCancel}
            size="md"
            title="Escribano"
            tipName={TIPS.NAME.MODALS.ESCRIBANO_MODAL}
            body={(
                <div className='row form-basic'>
                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                          name="orden"
						  type="number"
						  placeholder=""
						  className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
						  value={formValues.orden}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
                    <div className="col-12 col-md-5">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="nombre" required>Matrícula</FormLabel>
                        <input
                            type="text"
                            name="matricula"
                            className={`form-control ${errorOf('matricula') ? 'is-invalid' : ''}`}
                            value={formValues.matricula}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('matricula')} />
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    {props.editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={onConfirm}>Guardar</button>
                    )}
                </div>
                
            )}
        />
    </>
}

export default EscribanoModal
